export const Colors = {
  colorPrimary: '#FFF',
  colorAccent: '#3440b4',
  colorVodafone: '#E60000',
  colorAccentLight: '#F6A3A3',
  colorSecondary: '#e68620',
  colorSecondaryLight: '#ffb652',
  colorRed: '#FE0000',

  colorMen: '#00a94d',
  colorWomen: '#8166ac',

  colorBlack: '#000',
  colorN100: '#1A1E29',
  colorN90: '#292D3A',
  colorN80: '#383D4C',
  colorN70: '#4B505F',
  colorN75: '#666666',
  colorN60: '#626775',
  colorN50: '#787D8B',
  colorN40: '#9397A2',
  colorN30: '#AEB1B9',
  colorN20: '#C9CBD1',
  colorN15: '#CCCCCC',
  colorN10: '#E4E5E8',
  colorN05: '#F2F2F4',
  colorWhite: '#FFF',

  generalLegend: [
    '#510009',
    '#990000',
    '#e60000',
    '#fe5f12',
    '#ffc350',
    '#ffffae',
  ],
  poiLegend: ['#253494', '#2C7FB8', '#41B6C4', '#7FCDBB', '#C7E9b4', '#FFFFCC'],

  campaignLegend: ['#045275', '#089099', '#7CCBA2', '#F7FEAE'],

  originDestinationGeneral: [
    '#ffffae',
    '#ffda6e',
    '#ffb340',
    '#ff4000',
    '#bf0020',
  ],
  originDestinationSelected: [
    '#263593',
    '#2C7FB8',
    '#40B6C4',
    '#7ECEBB',
    '#C7E9B4',
    '#FEFFCC',
  ],

  legendTemporalComparison: [
    '#D02460',
    '#E4676A',
    '#FFB170',
    '#FFF192',
    '#BFD15A',
    '#6FB56A',
    '#22925B',
  ],
  legendSpatialComparison: [
    '#bf0020',
    '#f3390b',
    '#ffb340',
    '#f8e71c',
    '#64d0ec',
    '#3399cc',
    '#3969ac',
  ],

  barChart: ['#d8daf6', '#c4c8f2', '#9da4ea', '#757fe1', '#616ddd', '#3a48d4'],
  barChartCompared: [
    '#e68620',
    '#eb902b',
    '#f09935',
    '#f5a33f',
    '#faac49',
    '#ffb652',
  ],
  lineChart: ['#E60000', '#FF6800', '#7F3C8D', '#2AA9D3', '#194C88'],
  heatmapChart: ['#FFFFAE', '#FFDA6E', '#FF8D2E', '#F3390B', '#BF0020'],
  rankingChart: ['#E73F74', '#F2B701', '#7F3C8D', '#11A579', '#3969AC'],

  colorTeal: '#0F7483',

  colorPinkLight: '#F5645F',
  colorPinkLighter: '#F97B72',
  colorGeographica: '#15B750',

  colorYellow: '#f2b701',

  colorDarkMatter: '#0D0D0D',

  colorDisabled: '#C9CBD1',

  colorCarto: '#162945',

  colorChanged: '#E68310',
  colorUp: '#11A579',
  colorDown: '#E73F74',
  colorHighlight: '#f0d2ac',
}
export const Constants: any = {
  logo: '/assets/img/brands/politis/avatar-gooh.svg',
  logoBig: '/assets/img/brands/politis/logo-gooh.svg',
  loginBg: '/assets/img/brands/politis/login-bg.png',
}
